import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import Select from 'react-select'
import { main_url, getFirstDayOfMonth } from '../../utils/CommonFunction'
import moment from 'moment';
import DatePicker from 'react-datetime';
import { getHeaders } from '../../utils/apiHelper';

class CompensationandBenefit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toDate: moment(),
      fromDate: moment(getFirstDayOfMonth()),
      chartOptions: {},
      name: [],
      amount: [],
      branchData: [],
      deptData: [],
      date:[],
      dataRow:[],
      uniqueMap:null,
      mapValue:null,
      finalMap:[],
      seriesData:[],
      chartData: [],
    }
  }


  componentDidMount() {
    this.setChartOption()
    this.getBenefit()
    

  }
 
  filter() {
    let s_date = moment(this.state.fromDate).format("YYYY-MM-DD");
    let e_date = moment(this.state.toDate).format("YYYY-MM-DD");

    this.getBenefit(
        s_date,
        e_date,


    );
}
  handleFromDate = (event) => {
    this.setState({
      fromDate: event
    });
  };
  handleToDate = (event) => {
    this.setState({
      toDate: event
    });
  };
  getBenefit = () => {
    fetch(main_url + 'dashboard/compensationBenefit'+'/'+ moment(this.state.fromDate).format("YYYY-MM-DD")+'/'+ moment(this.state.toDate).format("YYYY-MM-DD")
    // , {method: 'GET'}
    , {
      headers: getHeaders(),
    }
    ).then(res =>
      res.json()
    ).then(data => {
      let temp = [];
      let dateArray = [];
      data.map((v) => {
        var obj = {};
        obj['name'] = v.name;
        let temp1 = [];
        v.amount.map((a) => {
          if (!dateArray.includes(a.Date)) {
            dateArray.push(a.Date);
          }
          
          temp1.push([a.Date, a.amount]);
        })
        obj['data'] = temp1;
        temp.push(obj);
      })
      var labelArray = [];
      temp.map(v => {
        labelArray.push(v.name);
      })
      this.setState({chartData: temp, date: dateArray});
  
      this.setChartOption();
    })

  }
  
  setChartOption = () => {
    const chartOptions = {
      chart: {
        type: 'line',
        height: '400px',
      },

      title: {
        text: '',
      },

      // subtitle: {
      //   text: ''
      // },
      yAxis: {
        min: 0, tickInterval: 10000000,
        title: {
          text: ""
        },
        labels: {
          format: '{value}',
        }
      },

      xAxis: {
        categories: this.state.date,
        // tickmarkPlacement: 'on',
        title: {
          enabled: true
        }
      },
      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.category}, {point.y:,.0f} millions, {point.percentage:.1f}%.'
        }
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        x: 0,
        y: 0
      },
      // tooltip: {
      //   pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f} millions)<br/>',
      //   split: true
      // },
      plotOptions: {
      

        area: {
          stacking: 'percent',
          lineColor: '#ffffff',
          lineWidth: 1,
          marker: {
            lineWidth: 1,
            lineColor: '#ffffff'
          }
        }
      },
      // colorByPoint: true,
      // colors: ['#1f4545', '#3d86dy', '#193759', '#419191', '#9bcece', '#59c5c5', '#7ea8d9', '#344545', '#5c7c9f', '#59c5c5'],
      // series: [
      // {
      //   color:'#1f4545',
      //   name:this.state.dataRow.map(v=>{
      //     v.amount.map(v1=>v1.Date)
      //   }),
      //   data: this.state.dataRow.map(v=>{
      //     v.amount.map(v1=>
      //       v1.amount
      //     )
      //   })
       
      // }],
      series:this.state.chartData

    };

    this.setState({ chartOptions })

  }

  

  render() {
    return (
      <div
        className='text-center margin-y'
        style={{
          background: '#fff',
          color: '#222',
          boxShadow: '3px 3px 3px #e5e5e5',
          borderRadius: 6,
          padding: '2px 0px 2px 0px'
        }}
      >
        <h3 className='' style={{ padding: '10px 0px 0px 0px', marginBottom: '20px' }}>Compensation and Benefit</h3>
        <div className='flex-row' style={{ display: 'flex', justifyContent: 'start', alignItems: 'end', margin: '10px 10px 0px 10px' }}>

          <div style={{ textAlign: 'start', display: 'fexl flex-col'}}>
            <label htmlFor="" >Start Date</label>
            <div style={{ }}>
              <DatePicker className='fromdate'
                dateFormat="DD/MM/YYYY"
                value={this.state.fromDate}
                onChange={this.handleFromDate}
                timeFormat={false} />
            </div>
          </div>

          <div style={{ textAlign: 'start', display: 'fexl flex-col' }}>
            <label htmlFor="">End Date</label>
            <div style={{ }}>
              < DatePicker className='fromdate'
                dateFormat="DD/MM/YYYY"
                value={this.state.toDate}
                onChange={this.handleToDate}
                timeFormat={false} />

            </div>
          </div>

          <button className='btn btn-primary text-center' style={{ height: 30, padding: '0px 5px 0px 5px' }} onClick={this.filter.bind(this)}>Search</button>
        </div>
        <HighchartsReact
          highcharts={Highcharts}
          options={this.state.chartOptions}
          containerProps={{ className: "w-100" }} />
      </div>

    )
  }

}
export default CompensationandBenefit;
